import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoresWithContainerStationsQueryVariables = Types.Exact<{
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type StoresWithContainerStationsQuery = { __typename?: 'Query', storesWithContainerStations: Array<{ __typename?: 'IdName', id: string, name: string }> };


export const StoresWithContainerStationsDocument = gql`
    query StoresWithContainerStations($skip: Int!, $take: Int!) {
  storesWithContainerStations(skip: $skip, take: $take) {
    id
    name
  }
}
    `;

/**
 * __useStoresWithContainerStationsQuery__
 *
 * To run a query within a React component, call `useStoresWithContainerStationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresWithContainerStationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresWithContainerStationsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useStoresWithContainerStationsQuery(baseOptions: Apollo.QueryHookOptions<StoresWithContainerStationsQuery, StoresWithContainerStationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoresWithContainerStationsQuery, StoresWithContainerStationsQueryVariables>(StoresWithContainerStationsDocument, options);
      }
export function useStoresWithContainerStationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoresWithContainerStationsQuery, StoresWithContainerStationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoresWithContainerStationsQuery, StoresWithContainerStationsQueryVariables>(StoresWithContainerStationsDocument, options);
        }
export type StoresWithContainerStationsQueryHookResult = ReturnType<typeof useStoresWithContainerStationsQuery>;
export type StoresWithContainerStationsLazyQueryHookResult = ReturnType<typeof useStoresWithContainerStationsLazyQuery>;
export type StoresWithContainerStationsQueryResult = Apollo.QueryResult<StoresWithContainerStationsQuery, StoresWithContainerStationsQueryVariables>;